<template>
  <transition name="custom-bounce">
    <v-progress-circular v-if="show"
      class="progress"
      :width="3"
      color="primary"
      indeterminate
    />
  </transition>
</template>

<script>
/**
 * @group Resquest Flow Control
 * É o identificador de carregamento padrão usado pelo componente pai [Spinner](/components/Spinner)
 * para comunicar-se com o usuário.
*/
export default {
  props: {
    // Status de visualização do progress
    show: {
      type: Boolean
    }
  }
}
</script>

<style lang="stylus" scoped>
  .progress
    position absolute
    margin auto
    top 0
    right 0
    bottom 0
    left 0
</style>
